import React from 'react';
import { useInViewOnce } from '../../hooks/useInViewOnce';
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  /** Seconds of delay before the CSS transition starts */
  delay?: number;
}
export function Reveal({
  children,
  className = '',
  delay = 0
}: RevealProps) {
  const {
    ref,
    inView
  } = useInViewOnce<HTMLDivElement>(0.2);
  return <div ref={ref} className={`reveal ${inView ? 'is-visible' : ''} ${className}`} style={delay ? {
    transitionDelay: `${delay}s`
  } : undefined} data-id="element-143" data-mp="tf5a46o7jcpq">
      {children}
    </div>;
}